<template>
  <v-tooltip class="tooltip" :top="top" :bottom="bottom" :left="left" :right="right">
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on" class="btn-car relative">
        <slot><!-- Elemento que dispara a tooltip --></slot>
      </div>
    </template>
    <span style="white-space: pre-line;">{{ text }}</span>
  </v-tooltip>
</template>

<script>
// Tooltip para facilitar o entendimento do usuário
export default {
  name: 'ToolTip',
  components: {
  },
  props: {
    // Posiciona a tooltip acima do elemento
    top: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Posiciona a tooltip à esquerda do elemento
    left: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Posiciona a tooltip à direita do elemento
    right: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Posiciona a tooltip abaixo do elemento
    bottom: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Texto da tooltip
    text: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>

<style scoped>
  .btn-car { display: inline-block; }
  .tooltip { z-index: 100000 !important}
</style>
